import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './Login.css';

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Clicking the emailed link logs the browser into a temporary "recovery"
    // session; Supabase fires this event once that's in place.
    const { data: listener } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') setReady(true);
    });

    supabase.auth.getSession().then(({ data }) => {
      if (data.session) setReady(true);
    });

    return () => listener.subscription.unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    const { error: updateError } = await supabase.auth.updateUser({ password: newPassword });
    if (updateError) {
      setError(updateError.message);
      return;
    }

    setSuccess('Password updated. Redirecting you to sign in...');
    await supabase.auth.signOut();
    setTimeout(() => navigate('/login'), 2000);
  };

  return (
    <div className="login-page">
      <div className="login-bg">
        <div className="login-grid" />
      </div>

      <div className="login-container">
        <div className="login-brand">
          <img src="/bramley-logo.svg" alt="Bramley Engineering" className="login-logo-img" />
        </div>

        <div className="login-card">
          <div className="login-card-header">
            <img src="/vera-logo-header.svg" alt="Vera QMS" className="login-card-vera-logo" />
            <p className="login-subtitle">Set a new password</p>
          </div>

          {!ready && !success && (
            <p style={{ color: '#ccc', padding: '0 1.5rem 1.5rem' }}>
              Verifying your reset link... if this doesn't update in a few seconds, the link may have expired —
              request a new one from the login screen.
            </p>
          )}

          {ready && !success && (
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">NEW PASSWORD</label>
                <input
                  className="form-input"
                  type="password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  required
                  minLength={8}
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label className="form-label">CONFIRM NEW PASSWORD</label>
                <input
                  className="form-input"
                  type="password"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  required
                  minLength={8}
                />
              </div>

              {error && (
                <div className="login-error">
                  <span className="error-icon">!</span>
                  {error}
                </div>
              )}

              <button className="login-btn" type="submit">SET NEW PASSWORD</button>
            </form>
          )}

          {success && (
            <div className="login-form">
              <div className="login-error" style={{ background: '#1e3a1e', color: '#8fd98f' }}>
                {success}
              </div>
            </div>
          )}

          <div className="login-footer">
            <span className="login-version">Vera v1.0 — Bramley Engineering</span>
          </div>
        </div>
      </div>
    </div>
  );
}
